import {
  formatBundleReplacementPercent,
  formatBundleReplacementUnits,
  getBundleReplacementStatusLabel,
  rowHasBundleReplacementException,
} from '../../../lib/bundleReplacementShiftHelpers';

function statusTone(hasException) {
  return hasException
    ? 'border-transparent bg-amber-50 text-amber-700'
    : 'border-transparent bg-emerald-50 text-emerald-700';
}

export function BundleReplacementShiftMainTable({ rows }) {
  return (
    <div className="overflow-hidden rounded-lg border border-gray-200 bg-white">
      <div className="max-h-[calc(100vh-18rem)] overflow-auto">
        <table className="min-w-full text-left text-sm">
          <thead className="sticky top-0 z-10 bg-slate-50 text-xs uppercase tracking-[0.12em] text-gray-500">
            <tr>
              <th className="px-4 py-3 font-medium">Execution SKU</th>
              <th className="px-4 py-3 font-medium">Bundle product</th>
              <th className="px-4 py-3 font-medium">Original component</th>
              <th className="px-4 py-3 font-medium">Replacement SKU</th>
              <th className="px-4 py-3 font-medium">Replacement product</th>
              <th className="px-4 py-3 text-right font-medium">Shift %</th>
              <th className="px-4 py-3 text-right font-medium">Bundle component demand</th>
              <th className="px-4 py-3 text-right font-medium">Shifted bundle demand</th>
              <th className="px-4 py-3 font-medium">Status</th>
            </tr>
          </thead>
          <tbody>
            {rows.length > 0 ? (
              rows.map(row => {
                const hasException = rowHasBundleReplacementException(row);
                return (
                  <tr key={row.id} className="border-b border-gray-100 hover:bg-gray-50">
                    <td className="px-4 py-3 align-top font-medium text-gray-900">{row.executionSku}</td>
                    <td className="px-4 py-3 align-top text-gray-600">{row.executionProductName}</td>
                    <td className="px-4 py-3 align-top">
                      <p className="font-medium text-gray-900">{row.originalComponentSku}</p>
                      <p className="mt-1 text-xs text-gray-500">{row.originalComponentProductName}</p>
                    </td>
                    <td className="px-4 py-3 align-top font-medium text-gray-900">{row.replacementSku}</td>
                    <td className="px-4 py-3 align-top text-gray-600">{row.replacementProductName}</td>
                    <td className="px-4 py-3 text-right align-top text-gray-900">
                      {formatBundleReplacementPercent(row.shiftPercent)}
                    </td>
                    <td className="px-4 py-3 text-right align-top text-gray-900">
                      {formatBundleReplacementUnits(row.bundleComponentDemand)}
                    </td>
                    <td className="px-4 py-3 text-right align-top font-medium text-gray-900">
                      {formatBundleReplacementUnits(row.shiftedBundleDemand)}
                    </td>
                    <td className="px-4 py-3 align-top">
                      <span
                        className={`inline-flex rounded-md border px-2 py-1 text-[11px] font-medium ${statusTone(hasException)}`}
                      >
                        {getBundleReplacementStatusLabel(row)}
                      </span>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td className="px-4 py-10 text-center text-sm text-gray-500" colSpan={9}>
                  No bundle replacement rows match the current filters.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
